<template>
  <div>
    <div class="keypad-bg">
      <div v-for="item in 6" :key="item"></div>
    </div>
    <div class="pwd-input">
      <div v-for="item in keypadSwitch" :key="item"></div>
    </div>
    <input
      v-if="padSwitch"
      type="password"
      maxlength="6"
      id="passwd1"
      name="passwd"
      class="pw-input"
      @input="firstPwd($event)"
      ds-kb-type="number"
      ds-kb-focus="false"
      ds-kb-xy="[0, 0]"
      inputmode="numeric"
      v-model="passwd"
    />
    <input
      v-else
      type="password"
      maxlength="6"
      id="passwd2"
      name="passwd"
      class="pw-input"
      @input="secondPwd($event)"
      ds-kb-type="number"
      ds-kb-focus="false"
      ds-kb-xy="[0, 0]"
      inputmode="numeric"
      v-model="confirmPasswd"
    />
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
export default {
  props: {
    padSwitch: Boolean
  },
  data () {
    return {
      passwd: '',
      confirmPasswd: ''
    }
  },
  methods: {
    firstPwd (event) {
      if (event.target.value.length === 6) {
        this.$emit('firstPwd', Base64.encode(this.passwd))
      }
    },
    secondPwd (event) {
      if (event.target.value.length === 6) {
        this.$emit('secondPwd', Base64.encode(this.confirmPasswd))
      }
    }
  },
  computed: {
    keypadSwitch () {
      return this.padSwitch ? this.passwd.length : this.confirmPasswd.length
    }
  }
}
</script>

<style>

</style>
